/**
 * Normalizes serialization artifacts (tagged wire values like `{"$$date": …}`
 * and hydrated class instances) to plain JSON. Never throws.
 */
export function normalizeWireArtifacts(value: unknown): unknown {
  if (value === undefined) {
    return null;
  }
  if (typeof value === "bigint") {
    return value.toString();
  }
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(normalizeWireArtifacts);
  }
  const toJson = (value as { toJSON?: unknown }).toJSON;
  if (typeof toJson === "function") {
    return normalizeWireArtifacts((toJson as () => unknown).call(value));
  }
  const entries = Object.entries(value);
  if (entries.length === 1) {
    const [key, tagged] = entries[0]!;
    if (
      key === "$$date" &&
      (typeof tagged === "string" || typeof tagged === "number")
    ) {
      const date = new Date(tagged);
      return Number.isNaN(date.getTime()) ? null : date.toISOString();
    }
    if (key === "$$undefined") {
      return null;
    }
  }
  return Object.fromEntries(
    entries
      .filter(([, entryValue]) => entryValue !== undefined)
      .map(([key, entryValue]) => [key, normalizeWireArtifacts(entryValue)]),
  );
}
